import { render, staticRenderFns } from "./SvgAuditorium.vue?vue&type=template&id=453da4d7&"
import script from "./SvgAuditorium.vue?vue&type=script&lang=js&"
export * from "./SvgAuditorium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports